// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"91005b6e","455":"6a8e2007","977":"d5b6e0ee"}[chunkId] + ".chunk.js";
};